var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgToTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 15 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  width: "14px",
  height: "14px"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.193 5.511a1.111 1.111 0 00-1.57 0l-5.556 5.556a1.111 1.111 0 001.57 1.57l3.66-3.66v9.912a1.111 1.111 0 002.222 0V8.978l3.659 3.659a1.11 1.11 0 001.57-1.57L8.193 5.51zM13.704 2.222a1.111 1.111 0 000-2.222H1.11a1.111 1.111 0 000 2.222h12.593z",
  fill: "#fff"
})));
export { SvgToTop as ReactComponent };
export default __webpack_public_path__ + "assets/icons/toTop.7486f4.svg";